<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="pa-0">
        <v-card max-width="700" flat class="mx-auto pa-xs-0 pa-sm-10 pt-sm-5">
          <v-row aline="center" justify="center">
            <p class="title">
              介護記録一覧 -
              <span class="ym"
                >{{ calday.year() }}年{{ calday.month() + 1 }}月</span
              >
            </p>
          </v-row>

          <v-row justify="space-around" class="pa-1">
            <v-col cols="6" style="background-color: white">
              <v-btn @click="moveLastMonth()">
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>

              <v-btn @click="moveNextMonth()">
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-col>

            <v-checkbox
              v-model="ka"
              color="success"
              label="確定"
              @change="searchlist(false)"
            />
            <v-checkbox
              v-model="mi"
              label="未入力"
              @change="searchlist(false)"
            />

            <v-col cols="12" style="background-color: white">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="検索キーワードを入力してください"
                single-line
                hide-details
                @input="searchlist(false)"
              />
            </v-col>
          </v-row>

          <v-row align="center">
            <v-list two-line width="100%">
              <v-list-item-group>
                <template v-for="item in ditems">
                  <v-list-item :key="item.id" class="listitem" inactive>
                    <v-list-item-content>
                      <v-list-item-title v-if="!item.jid">
                        <v-icon small>query_builder</v-icon>
                        {{ formatDate(item.date) }} {{ item.kaisi }}-{{
                          item.syuryo
                        }}
                      </v-list-item-title>
                      <v-list-item-title v-if="item.jid">
                        <v-icon small>query_builder</v-icon>
                        {{ formatDate(item.jdate) }}
                        <span :class="{ 'red--text': item.jkaisif }">{{
                          item.jkaisi
                        }}</span>
                        -
                        <span :class="{ 'red--text': item.jsyuryof }">{{
                          item.jsyuryo
                        }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="subtitle-1 black--text">
                        <v-icon small>person</v-icon>
                        {{ item.rimyoji }}{{ item.riname }} 担当：{{
                          item.staffname
                        }}
                        {{ item.dokoname }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn
                        v-if="chkJisseki(item) == 'jimu'"
                        color="warning"
                        disabled
                        >事務</v-btn
                      >

                      <v-btn
                        v-if="chkJisseki(item) == 'can'"
                        color="warning"
                        disabled
                        >支援キャンセル</v-btn
                      >

                      <v-btn
                        v-if="chkJisseki(item) == 'upd'"
                        color="warning"
                        @click="editItem(item)"
                      >
                        修正可能
                        <v-icon dark right>edit</v-icon>
                      </v-btn>

                      <v-btn
                        v-if="chkJisseki(item) == 'cmt'"
                        color="success"
                        @click="viewItem(item)"
                      >
                        入力確定
                        <v-icon dark right>check_box</v-icon>
                      </v-btn>

                      <v-btn
                        v-if="chkJisseki(item) == 'ins'"
                        color="primary"
                        @click="editItem(item)"
                      >
                        記録入力
                        <v-icon dark right>create</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>

            <v-pagination
              v-model="page"
              :length="pagelength"
              @input="pageChange"
            />

            <v-dialog v-model="dialog" fullscreen>
              <v-toolbar dark dense>
                <v-toolbar-title>実績＆テレッサ入力</v-toolbar-title>

                <v-spacer />

                <v-btn @click="dialog = false">
                  <v-icon>close</v-icon>閉じる
                </v-btn>
              </v-toolbar>

              <v-card>
                <v-card-text class="pa-2">
                  <v-container>
                    <v-row dense>
                      <v-col cols="12" xs="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.fullname"
                          dense
                          disabled
                          label="利用者名"
                        />
                      </v-col>
                      <v-col cols="12" xs="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.staffname"
                          dense
                          disabled
                          label="担当者名"
                        />
                      </v-col>
                      <v-card width="100%" class="pa-4">
                        <v-card-title class="pa-0 pb-4" tile
                          >実績入力(予定と違う場合のみ変更してください)</v-card-title
                        >
                        <v-row dense>
                          <v-col cols="12" xs="12" sm="6" md="6">
                            <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItem.date"
                                  label="日付を選択してください"
                                  prepend-icon="event"
                                  readonly
                                  dense
                                  class="pt-1"
                                  v-on="on"
                                />
                              </template>
                              <v-date-picker
                                v-model="editedItem.date"
                                dense
                                locale="ja"
                                @input="menu = false"
                              />
                            </v-menu>
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.kaisi"
                              dense
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.syuryo"
                              dense
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="px-10">
                          <div class="text-center">
                            <v-dialog v-model="candialog" width="500">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="red lighten-2"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  キャンセルはこちら
                                </v-btn>
                              </template>

                              <v-card>
                                <v-card-title class="headline grey lighten-2">
                                  支援キャンセル
                                </v-card-title>

                                <v-card-text>
                                  <p class="ma-3">
                                    キャンセルボタンを押すと支援キャンセルされ、支援記録は入力できません、よろしいですか？
                                  </p>
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="warning"
                                    block
                                    outlined
                                    :disabled="viewonly"
                                    @click="cancelItem(editedItem)"
                                  >
                                    支援キャンセルします。
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </div>
                        </v-row>
                      </v-card>

                      <v-card width="100%" class="pa-4 mt-2" tile>
                        <v-card-title class="pa-0 pb-5">支援詳細</v-card-title>
                        <div class="overline mb-4">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :disabled="viewonly"
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                >直近5件からの実績から簡単入力</v-btn
                              >
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="(item, index) in kantans"
                                :key="index"
                                @click="kantanset(item)"
                              >
                                <v-list-item-title>
                                  {{ formatDate(item.date) }}
                                  {{ item.riname }}
                                  {{ item.kaisi }} - {{ item.syuryo }}
                                  {{ editedItem.staffname }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>

                        <v-row dense>
                          <v-col cols="12" xs="12" sm="12" md="12">
                            <v-checkbox
                              v-model="editedItem.kinkyu"
                              :disabled="viewonly"
                              class="mr-2"
                              color="red"
                              label="緊急対応の場合、チェックを入れてください。"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6" xs="6" sm="6" md="6">
                            <v-checkbox
                              v-model="editedItem.hutari"
                              :disabled="viewonly"
                              class="mr-2"
                              label="二人派遣"
                            />
                          </v-col>
                          <v-col cols="6" xs="6" sm="6" md="6">
                            <v-select
                              v-model="editedItem.dokoid"
                              :items="staffs"
                              :disabled="viewonly"
                              item-text="staffname"
                              item-value="id"
                              label="同行者"
                            ></v-select>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >身体介護時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.skaisi"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.ssyuryo"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >家事支援時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.kkaisi"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.ksyuryo"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >重度訪問時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.jkaisi"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.jsyuryo"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >移動支援時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.ikaisi"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.isyuryo"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >通院介助時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.tkaisi"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.tsyuryo"
                              :disabled="viewonly"
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-card width="100%" class="pa-4 mt-2" tile>
                        <v-card-title class="pa-0 pb-2"
                          >支援内容詳細入力</v-card-title
                        >
                        <v-row class="px-3">
                          <v-checkbox
                            v-model="editedItem.syokuji"
                            :disabled="viewonly"
                            class="mr-2"
                            label="食事"
                          />
                          <v-checkbox
                            v-model="editedItem.kouku"
                            :disabled="viewonly"
                            class="mr-2"
                            label="口腔"
                          />
                          <v-checkbox
                            v-model="editedItem.seiyo"
                            :disabled="viewonly"
                            class="mr-2"
                            label="整容"
                          />
                          <v-checkbox
                            v-model="editedItem.suiho"
                            :disabled="viewonly"
                            class="mr-2"
                            label="水補"
                          />
                          <v-checkbox
                            v-model="editedItem.ijo"
                            :disabled="viewonly"
                            class="mr-2"
                            label="移乗"
                          />
                          <v-checkbox
                            v-model="editedItem.koui"
                            :disabled="viewonly"
                            class="mr-2"
                            label="更衣"
                          />
                          <v-checkbox
                            v-model="editedItem.seisiki"
                            :disabled="viewonly"
                            class="mr-2"
                            label="清拭"
                          />
                          <v-checkbox
                            v-model="editedItem.nyuyoku"
                            :disabled="viewonly"
                            class="mr-2"
                            label="入浴"
                          />
                          <v-checkbox
                            v-model="editedItem.haisetu"
                            :disabled="viewonly"
                            class="mr-2"
                            label="排泄"
                          />
                          <v-checkbox
                            v-model="editedItem.hukuyaku"
                            :disabled="viewonly"
                            class="mr-2"
                            label="服薬"
                          />
                          <v-checkbox
                            v-model="editedItem.taii"
                            :disabled="viewonly"
                            class="mr-2"
                            label="体位"
                          />
                          <v-checkbox
                            v-model="editedItem.tomo"
                            :disabled="viewonly"
                            class="mr-2"
                            label="共に行う家事"
                          />
                          <v-checkbox
                            v-model="editedItem.etc"
                            :disabled="viewonly"
                            class="mr-2"
                            label="その他"
                          />
                          <v-checkbox
                            v-model="editedItem.kaimono"
                            :disabled="viewonly"
                            class="mr-2"
                            label="買い物"
                          />
                          <v-checkbox
                            v-model="editedItem.sentaku"
                            :disabled="viewonly"
                            class="mr-2"
                            label="洗濯"
                          />
                          <v-checkbox
                            v-model="editedItem.seiri"
                            :disabled="viewonly"
                            class="mr-2"
                            label="整理"
                          />
                          <v-checkbox
                            v-model="editedItem.soji"
                            :disabled="viewonly"
                            class="mr-2"
                            label="掃除"
                          />
                          <v-checkbox
                            v-model="editedItem.bedmk"
                            :disabled="viewonly"
                            class="mr-2"
                            label="ベッドメイク"
                          />
                          <v-checkbox
                            v-model="editedItem.tyori"
                            :disabled="viewonly"
                            class="mr-2"
                            label="調理"
                          />
                        </v-row>
                        <v-row class="px-5">
                          <v-textarea
                            v-model="editedItem.sonota"
                            solo
                            name="input-7-4"
                            label="詳しい内容・ご利用者のご様子・引継ぎ事項など"
                            :disabled="viewonly"
                          />
                        </v-row>
                        <!-- <v-row class="px-5">
                          <v-textarea
                            v-model="editedItem.hiyari"
                            solo
                            name="input-7-4"
                            label="ヒヤリハット"
                            :disabled="viewonly"
                          />
                        </v-row> -->
                        <v-row class="px-5">
                          <v-text-field
                            v-model="editedItem.taion"
                            :disabled="viewonly"
                            label="体温"
                            outlined
                          />
                        </v-row>
                        <v-row class="px-10">
                          <v-checkbox
                            v-model="editedItem.riinfo"
                            class="mr-2"
                            label="利用者情報共有へ追加"
                          />
                        </v-row>
                      </v-card>

                      <v-card width="100%" class="pa-4 mt-2" tile>
                        <v-card-title class="pa-0 pb-2"
                          >移動支援・通院支援詳細</v-card-title
                        >
                        <v-row class="px-3">
                          <v-col>
                            <v-checkbox
                              v-model="editedItem.jidoari"
                              :disabled="viewonly"
                              class="mr-2"
                              label="重度訪問介護移動支援あり"
                            />
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="editedItem.jido"
                              :disabled="viewonly"
                              outlined
                              label="移動中加算時間"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="px-3">
                          <v-checkbox
                            v-model="editedItem.ikaigoari"
                            :disabled="viewonly"
                            class="mr-2"
                            label="移動支援介護あり"
                          />
                          <v-checkbox
                            v-model="editedItem.ikaigonasi"
                            :disabled="viewonly"
                            class="mr-2"
                            label="移動支援介護なし"
                          />
                        </v-row>
                        <v-row class="px-3">
                          <v-textarea
                            v-model="editedItem.imoku"
                            solo
                            name="input-7-4"
                            label="移動支援 目的地"
                            :disabled="viewonly"
                          />
                        </v-row>
                        <v-row class="px-3">
                          <v-textarea
                            v-model="editedItem.isyu"
                            solo
                            name="input-7-4"
                            label="移動支援 移動手段"
                            :disabled="viewonly"
                          />
                        </v-row>
                        <v-row class="px-3">
                          <v-checkbox
                            v-model="editedItem.tkaigoari"
                            :disabled="viewonly"
                            class="mr-2"
                            label="通院支援介護あり"
                          />
                          <v-checkbox
                            v-model="editedItem.tkaigonasi"
                            :disabled="viewonly"
                            class="mr-2"
                            label="通院支援介護なし"
                          />
                        </v-row>
                      </v-card>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn @click="dialog = false">
                    <v-icon>close</v-icon>閉じる
                  </v-btn>
                  <v-btn v-if="!viewonly" class="warning" @click="conf"
                    >確認画面へ</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="confdialog" fullscreen>
              <v-toolbar dark dense>
                <v-toolbar-title>確認画面</v-toolbar-title>

                <v-spacer />

                <v-btn @click="confdialog = false">
                  <v-icon>close</v-icon>閉じる
                </v-btn>
              </v-toolbar>

              <v-card>
                <v-card-text class="pa-2">
                  <v-container>
                    <v-row dense>
                      <v-col cols="12" xs="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.fullname"
                          dense
                          disabled
                          label="利用者名"
                        />
                      </v-col>
                      <v-col cols="12" xs="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.staffname"
                          dense
                          disabled
                          label="担当者名"
                        />
                      </v-col>
                      <v-card width="100%" class="pa-4">
                        <v-card-title class="pa-0 pb-4" tile
                          >実績入力</v-card-title
                        >
                        <v-row dense>
                          <v-col cols="12" xs="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.date"
                              dense
                              disabled
                              label="日付"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.kaisi"
                              dense
                              disabled
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.syuryo"
                              dense
                              disabled
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-card width="100%" class="pa-4 mt-2" tile>
                        <v-card-title class="pa-0 pb-5"
                          >実績時間内訳</v-card-title
                        >

                        <v-row dense>
                          <v-col cols="12" xs="12" sm="12" md="12">
                            <v-checkbox
                              v-model="editedItem.kinkyu"
                              disabled
                              class="mr-2"
                              label="緊急対応の場合、チェックを入れてください。"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6" xs="6" sm="6" md="6">
                            <v-checkbox
                              v-model="editedItem.hutari"
                              disabled
                              class="mr-2"
                              label="二人派遣"
                            />
                          </v-col>
                          <v-col cols="6" xs="6" sm="6" md="6">
                            <v-select
                              v-model="editedItem.dokoid"
                              :items="staffs"
                              disabled
                              item-text="staffname"
                              item-value="id"
                              label="同行者"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >身体介護時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.skaisi"
                              disabled
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.ssyuryo"
                              disabled
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >家事支援時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.kkaisi"
                              disabled
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.ksyuryo"
                              disabled
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >重度訪問時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.jkaisi"
                              disabled
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.jsyuryo"
                              disabled
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >移動支援時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.ikaisi"
                              disabled
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.isyuryo"
                              disabled
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" xs="2" sm="2" md="2"
                            >通院介助時間</v-col
                          >
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.tkaisi"
                              disabled
                              type="time"
                              step="900"
                              label="開始"
                            />
                          </v-col>
                          <v-col cols="12" xs="6" sm="3" md="3">
                            <v-text-field
                              v-model="editedItem.tsyuryo"
                              disabled
                              type="time"
                              step="900"
                              label="終了"
                            />
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-card width="100%" class="pa-4 mt-2" tile>
                        <v-card-title class="pa-0 pb-2"
                          >支援内容詳細入力</v-card-title
                        >
                        <v-row class="px-3">
                          <v-checkbox
                            v-model="editedItem.syokuji"
                            disabled
                            class="mr-2"
                            label="食事"
                          />
                          <v-checkbox
                            v-model="editedItem.kouku"
                            disabled
                            class="mr-2"
                            label="口腔"
                          />
                          <v-checkbox
                            v-model="editedItem.seiyo"
                            disabled
                            class="mr-2"
                            label="整容"
                          />
                          <v-checkbox
                            v-model="editedItem.suiho"
                            disabled
                            class="mr-2"
                            label="水補"
                          />
                          <v-checkbox
                            v-model="editedItem.ijo"
                            disabled
                            class="mr-2"
                            label="移乗"
                          />
                          <v-checkbox
                            v-model="editedItem.koui"
                            disabled
                            class="mr-2"
                            label="更衣"
                          />
                          <v-checkbox
                            v-model="editedItem.seisiki"
                            disabled
                            class="mr-2"
                            label="清拭"
                          />
                          <v-checkbox
                            v-model="editedItem.nyuyoku"
                            disabled
                            class="mr-2"
                            label="入浴"
                          />
                          <v-checkbox
                            v-model="editedItem.haisetu"
                            disabled
                            class="mr-2"
                            label="排泄"
                          />
                          <v-checkbox
                            v-model="editedItem.hukuyaku"
                            disabled
                            class="mr-2"
                            label="服薬"
                          />
                          <v-checkbox
                            v-model="editedItem.taii"
                            disabled
                            class="mr-2"
                            label="体位"
                          />
                          <v-checkbox
                            v-model="editedItem.tomo"
                            disabled
                            class="mr-2"
                            label="共に行う家事"
                          />
                          <v-checkbox
                            v-model="editedItem.etc"
                            disabled
                            class="mr-2"
                            label="その他"
                          />
                          <v-checkbox
                            v-model="editedItem.kaimono"
                            disabled
                            class="mr-2"
                            label="買い物"
                          />
                          <v-checkbox
                            v-model="editedItem.sentaku"
                            disabled
                            class="mr-2"
                            label="洗濯"
                          />
                          <v-checkbox
                            v-model="editedItem.seiri"
                            disabled
                            class="mr-2"
                            label="整理"
                          />
                          <v-checkbox
                            v-model="editedItem.soji"
                            disabled
                            class="mr-2"
                            label="掃除"
                          />
                          <v-checkbox
                            v-model="editedItem.bedmk"
                            disabled
                            class="mr-2"
                            label="ベッドメイク"
                          />
                          <v-checkbox
                            v-model="editedItem.tyori"
                            disabled
                            class="mr-2"
                            label="調理"
                          />
                        </v-row>
                        <v-row class="px-5">
                          <v-textarea
                            v-model="editedItem.sonota"
                            solo
                            name="input-7-4"
                            label="詳しい内容・ご利用者のご様子・引継ぎ事項など"
                            disabled
                          />
                        </v-row>
                        <!-- <v-row class="px-5">
                          <v-textarea
                            v-model="editedItem.hiyari"
                            solo
                            name="input-7-4"
                            label="ヒヤリハット"
                            disabled
                          />
                        </v-row> -->
                        <v-row class="px-5">
                          <v-text-field
                            v-model="editedItem.taion"
                            disabled
                            label="体温"
                            outlined
                          />
                        </v-row>

                        <v-row class="px-10">
                          <v-checkbox
                            v-model="editedItem.riinfo"
                            class="mr-2"
                            disabled
                            label="利用者情報共有へ追加"
                          />
                        </v-row>
                      </v-card>

                      <v-card width="100%" class="pa-4 mt-2" tile>
                        <v-card-title class="pa-0 pb-2"
                          >移動支援・通院支援詳細</v-card-title
                        >
                        <v-row class="px-3">
                          <v-col>
                            <v-checkbox
                              v-model="editedItem.jidoari"
                              disabled
                              class="mr-2"
                              label="重度訪問介護移動支援あり"
                            />
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="editedItem.jido"
                              disabled
                              outlined
                              label="移動中加算時間"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="px-3">
                          <v-checkbox
                            v-model="editedItem.ikaigoari"
                            disabled
                            class="mr-2"
                            label="移動支援介護あり"
                          />
                          <v-checkbox
                            v-model="editedItem.ikaigonasi"
                            disabled
                            class="mr-2"
                            label="移動支援介護なし"
                          />
                        </v-row>
                        <v-row class="px-3">
                          <v-textarea
                            v-model="editedItem.imoku"
                            solo
                            name="input-7-4"
                            label="移動支援 目的地"
                            disabled
                          />
                        </v-row>
                        <v-row class="px-3">
                          <v-textarea
                            v-model="editedItem.isyu"
                            solo
                            name="input-7-4"
                            label="移動支援 移動手段"
                            disabled
                          />
                        </v-row>
                        <v-row class="px-3">
                          <v-checkbox
                            v-model="editedItem.tkaigoari"
                            disabled
                            class="mr-2"
                            label="通院支援介護あり"
                          />
                          <v-checkbox
                            v-model="editedItem.tkaigonasi"
                            disabled
                            class="mr-2"
                            label="通院支援介護なし"
                          />
                        </v-row>
                      </v-card>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <span style="color: red"
                    >入力内容に間違いがなければ保存ボタンを押してください</span
                  >
                  <v-spacer />
                  <v-btn @click="open"> <v-icon>undo</v-icon>戻る </v-btn>
                  <v-btn class="success" @click="save">保存</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-snackbar v-model="snackbar" color="info" :timeout="1000">{{
              msg
            }}</v-snackbar>
          </v-row>
        </v-card>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Common from "@/components/Common";
import moment from "moment";

export default {
  mixins: [Common],
  data: () => ({
    page: 1,
    pagelength: 5,
    pagesize: 20,
    ka: false,
    mi: true,
    dialog: false,
    confdialog: false,
    candialog: false,
    headers: [
      { text: "支援", value: "sien", width: "200px", filterable: true },
      { text: "実績入力", value: "jisseki", width: "100px", ortable: false }
    ],
    kantans: [],

    items: [],
    ditems: [],
    witems: [],
    menu: false,
    search: "",
    viewonly: false,
    editedIndex: -1,
    editedItem: {
      skaisi: "",
      ssyuryo: "",
      kkaisi: "",
      ksyuryo: "",
      jkaisi: "",
      jsyuryo: "",
      ikaisi: "",
      isyuryo: ""
    },
    defaultItem: {
      riname: "",
      hyoji: 0
    },
    calday: moment().date(1),
    caldata: [],
    msg: "",
    snackbar: "",
    services: [],
    staffs: []
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新規追加" : "編集";
    }
  },

  watch: {
    editedItem: {
      handler: function() {},
      deep: true
    }
  },

  created() {
    this.kousin();
  },

  mounted() {
    this.getServices();
    this.getStaffs();
  },

  methods: {
    searchlist: function(num) {
      this.witems = [];
      let self = this;
      this.items.forEach(function(item) {
        let text =
          item.date +
          item.rimyoji +
          item.riname +
          item.kaisi +
          item.syuryo +
          item.staffname;
        if (text.indexOf(self.search) != -1) self.witems.push(item);
      });
      let sitems = [];
      this.witems.forEach(function(item) {
        if (item.kaisi != item.jkaisi) item.jkaisif = true;
        if (item.syuryo != item.jsyuryo) item.jsyuryof = true;
        let st = self.chkJisseki(item);
        if (self.ka && (st == "cmt" || st == "can")) {
          sitems.push(item);
        } else if (self.mi && st != "cmt" && st != "can") {
          sitems.push(item);
        }
      });
      this.witems = sitems;
      this.pagelength = Math.ceil(this.witems.length / this.pagesize);
      var pg = 1;
      if (num) {
        pg = this.page;
      } else {
        this.page = 1;
      }
      this.pageChange(pg);
    },
    pageChange: function(pagenum) {
      this.ditems = this.witems.slice(
        this.pagesize * (pagenum - 1),
        this.pagesize * pagenum
      );
    },
    formatDate: function(date) {
      return moment(date).format("MM/DD (ddd)");
    },
    moveLastMonth: function() {
      this.keyid = 0;
      this.calday.add(-1, "months");
      this.kousin();
    },
    moveNextMonth: function() {
      this.keyid = 0;
      this.calday.add(1, "months");
      this.kousin();
    },
    getServices() {
      this.$axios.get(this.url + "getServices.php").then(response => {
        this.services = response.data;
      });
    },
    jisseki() {
      let self = this;
      this.$axios
        .post(
          this.url + "getJisseki.php",
          JSON.stringify({
            kaisi: this.editedItem.kaisi,
            syuryo: this.editedItem.syuryo,
            rid: this.editedItem.riid,
            staffid: this.editedItem.staffid,
            id: this.$store.getters.auth.id,
            jid: this.editedItem.jid
          })
        )
        .then(function(res) {
          if (res.data.length != 0) {
            self.editedItem = res.data[0];
            // let jis = res.data[0]
            // self.$set(self.editedItem, "kinkyu", jis.kinkyu)
            // self.$set(self.editedItem, "kaisi", jis.kaisi)
            // self.$set(self.editedItem, "syuryo", jis.syuryo)
            // self.$set(self.editedItem, "skaisi", jis.skaisi)
            // self.$set(self.editedItem, "ssyuryo", jis.ssyuryo)
            // self.$set(self.editedItem, "kkaisi", jis.kkaisi)
            // self.$set(self.editedItem, "ksyuryo", jis.ksyuryo)
            // self.$set(self.editedItem, "jkaisi", jis.jkaisi)
            // self.$set(self.editedItem, "jsyuryo", jis.jsyuryo)
            // self.$set(self.editedItem, "ikaisi", jis.ikaisi)
            // self.$set(self.editedItem, "isyuryo", jis.isyuryo)
            // self.$set(self.editedItem, "tkaisi", jis.tkaisi)
            // self.$set(self.editedItem, "tsyuryo", jis.tsyuryo)
            // self.$set(self.editedItem, "haisetu", jis.haisetu)
            // self.$set(self.editedItem, "syokuji", jis.syokuji)
            // self.$set(self.editedItem, "ijo", jis.ijo)
            // self.$set(self.editedItem, "kisyo", jis.kisyo)
            // self.$set(self.editedItem, "mimamori", jis.mimamori)
            // self.$set(self.editedItem, "omutu", jis.omutu)
            // self.$set(self.editedItem, "syusin", jis.syusin)
            // self.$set(self.editedItem, "hukuyaku", jis.hukuyaku)
            // self.$set(self.editedItem, "nyuyoku", jis.nyuyoku)
            // self.$set(self.editedItem, "soji", jis.soji)
            // self.$set(self.editedItem, "kaimono", jis.kaimono)
            // self.$set(self.editedItem, "taii", jis.taii)
            // self.$set(self.editedItem, "sonota", jis.sonota)
          }
        });
    },
    kantan() {
      let self = this;
      this.$axios
        .post(
          this.url + "getKantan.php",
          JSON.stringify({
            rid: this.editedItem.riid,
            staffid: this.editedItem.staffid
          })
        )
        .then(function(res) {
          self.kantans = res.data;
        });
    },
    kantanset(item) {
      let kantan = item;
      this.$set(this.editedItem, "kinkyu", kantan.kinkyu);
      this.$set(this.editedItem, "skaisi", kantan.skaisi);
      this.$set(this.editedItem, "ssyuryo", kantan.ssyuryo);
      this.$set(this.editedItem, "kkaisi", kantan.kkaisi);
      this.$set(this.editedItem, "ksyuryo", kantan.ksyuryo);
      this.$set(this.editedItem, "jkaisi", kantan.jkaisi);
      this.$set(this.editedItem, "jsyuryo", kantan.jsyuryo);
      this.$set(this.editedItem, "ikaisi", kantan.ikaisi);
      this.$set(this.editedItem, "isyuryo", kantan.isyuryo);
      this.$set(this.editedItem, "tkaisi", kantan.tkaisi);
      this.$set(this.editedItem, "tsyuryo", kantan.tsyuryo);

      this.$set(this.editedItem, "ikaigoari", kantan.ikaigoari);
      this.$set(this.editedItem, "ikaigonasi", kantan.ikaigonasi);
      this.$set(this.editedItem, "imoku", kantan.imoku);
      this.$set(this.editedItem, "isyu", kantan.isyu);
      this.$set(this.editedItem, "syokuji", kantan.syokuji);
      this.$set(this.editedItem, "kouku", kantan.kouku);
      this.$set(this.editedItem, "seiyo", kantan.seiyo);
      this.$set(this.editedItem, "suiho", kantan.suiho);
      this.$set(this.editedItem, "ijo", kantan.ijo);
      this.$set(this.editedItem, "koui", kantan.koui);
      this.$set(this.editedItem, "seisiki", kantan.seisiki);
      this.$set(this.editedItem, "nyuyoku", kantan.nyuyoku);
      this.$set(this.editedItem, "haisetu", kantan.haisetu);
      this.$set(this.editedItem, "hukuyaku", kantan.hukuyaku);
      this.$set(this.editedItem, "taii", kantan.taii);
      this.$set(this.editedItem, "tomo", kantan.tomo);
      this.$set(this.editedItem, "etc", kantan.etc);
      this.$set(this.editedItem, "kaimono", kantan.kaimono);
      this.$set(this.editedItem, "sentaku", kantan.sentaku);
      this.$set(this.editedItem, "seiri", kantan.seiri);
      this.$set(this.editedItem, "soji", kantan.soji);
      this.$set(this.editedItem, "bedmk", kantan.bedmk);
      this.$set(this.editedItem, "tyori", kantan.tyori);
      this.$set(this.editedItem, "jidoari", kantan.jidoari);
      this.$set(this.editedItem, "tkaigoari", kantan.tkaigoari);
      this.$set(this.editedItem, "tkaigonasi", kantan.tkaigonasi);
      this.$set(this.editedItem, "hutari", kantan.hutari);
      this.$set(this.editedItem, "doko", kantan.doko);
      this.$set(this.editedItem, "dokoid", kantan.dokoid);

      this.$set(this.editedItem, "sonota", kantan.sonota);
    },

    kousin() {
      let self = this;
      this.$axios
        .post(
          this.url + "getKirokuList.php",
          JSON.stringify({
            kaisi: moment(this.calday).format("YYYY-MM-DD"),
            syuryo: moment(this.calday)
              .add(1, "months")
              .format("YYYY-MM-DD"),
            today: "",
            order: "hiduke",
            id: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role
          })
        )
        .then(function(res) {
          self.items = res.data;
          self.ditems = self.items;
          self.pagelength = Math.ceil(self.items.length / self.pagesize);
          self.searchlist(true);
        });
    },
    viewItem(item) {
      this.editedItem = item;
      this.jisseki();
      this.viewonly = true;
      this.dialog = true;
    },
    editItem(item) {
      this.editedItem = item;
      this.editedItem.hutari = false;
      this.editedItem.riinfo = true;
      if (item.dokoname != null) {
        this.editedItem.hutari = true;
        this.editedItem.doko = item.dokoname;
      }
      if (this.chkJisseki(item) == "upd") this.jisseki();
      this.kantan();
      this.viewonly = false;
      this.dialog = true;
    },
    cancelItem(item) {
      let self = this;

      this.$axios
        .post(
          this.url + "cancelShift.php",
          JSON.stringify({
            item: item,
            id: this.$store.getters.auth.id
          })
        )
        .then(function() {
          self.msg = "更新完了しました。";
          self.snackbar = true;
          self.kousin();
          self.close();
        });
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("削除してもよろしいですか？") && this.items.splice(index, 1);
      let self = this;
      this.$axios
        .post(
          this.url + "user.php",
          JSON.stringify({
            st: "del",
            item: item
          })
        )
        .then(function() {
          self.msg = "削除完了しました。";
          self.snackbar = true;
          self.kousin();
          self.close();
        });
    },
    open() {
      this.confdialog = false;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    conf() {
      if (
        !this.chkarr(this.editedItem, "skaisi") &&
        !this.chkarr(this.editedItem, "ssyuryo") &&
        !this.chkarr(this.editedItem, "kkaisi") &&
        !this.chkarr(this.editedItem, "ksyuryo") &&
        !this.chkarr(this.editedItem, "jkaisi") &&
        !this.chkarr(this.editedItem, "jsyuryo") &&
        !this.chkarr(this.editedItem, "ikaisi") &&
        !this.chkarr(this.editedItem, "isyuryo") &&
        !this.chkarr(this.editedItem, "tkaisi") &&
        !this.chkarr(this.editedItem, "tsyuryo")
      ) {
        this.msg = "実績時間内訳が未入力です。入力してください。";
        this.snackbar = true;
      } else {
        this.dialog = false;
        this.confdialog = true;
      }
    },
    chkarr(arr, text) {
      if (!(text in arr) || !arr[text]) return false;
      if (arr[text] == "00:00" || arr[text] == "00:00:00") return false;
      return true;
    },
    confclose() {
      this.confdialog = false;
    },
    chkJisseki(item) {
      if (item.jimu == "1") {
        return "jimu";
      }
      if (item.cancel == "1") {
        return "can";
      } else if (item.jid == null) {
        return "ins";
      } else if (item.jid != "") {
        if (moment().diff(moment(item.jcd), "minute") < 120) {
          return "upd";
        } else if (this.$store.getters.auth.role == "admin") {
          return "upd";
        } else {
          return "cmt";
        }
      }
      return false;
    },
    getStaffs() {
      this.$axios.get(this.url + "getStaffs.php").then(response => {
        this.staffs = response.data;
      });
    },
    save() {
      let status = this.chkJisseki(this.editedItem);
      // if (this.chkJisseki(this.editedItem) != 'ins') status = 'upd'
      this.editedItem.updid = this.$store.getters.auth.id;
      let self = this;
      this.$axios
        .post(
          this.url + "updateJisseki.php",
          JSON.stringify({
            st: status,
            item: this.editedItem
          })
        )
        .then(function() {
          self.msg = "登録完了しました。";
          self.snackbar = true;
          self.kousin();
          self.close();
          self.confclose();
        });

      if (this.editedItem.riinfo) {
        this.editedItem.gyomu = 2;
        console.log(this.editedItem.taion);
        if (this.editedItem.taion != undefined) {
          this.editedItem.sonota =
            this.editedItem.sonota + "体温：" + this.editedItem.taion;
          this.editedItem.staffid = this.$store.getters.auth.id;
        }

        this.$axios
          .post(
            this.url + "updateRiinfo.php",
            JSON.stringify({
              item: this.editedItem
            })
          )
          .then(function() {});
      }
    }
  }
};
</script>

<style lang="stylus" scope>
.application {
}

.container {
  padding: 2;
}

:disabled {
  color: #000000 !important;
}

.hide {
  display: none;
}

.v-data-table__mobile-row {
  min-height: 25px !important;
}

.test {
  color: red;
}

.listitem {
  border-top: 1px solid #dcdcdc;
}
</style>
